import { useBetslipData } from './use-betslip-data';

export const useActiveGameMode = () => {
    //TODO: once we'll allow multiple game modes, we'll have to change/remove this
    const { selectedGameModes } = useBetslipData();
    return selectedGameModes[0];
};
